import React, { Component } from "react";
import { Table, Button } from "semantic-ui-react";
import _ from "lodash";
import PersonMetaData from "../../../metadata/PersonMetadata";
import Counties from "../Counties";
import SSNRiskReport from "./SSNRiskReport";
import CaseComponent from "../../common/CaseComponent";
import getSsn from "../../common/Ssn";
import Phone from "../Phone";
import { getNodeValue } from "../../common/Utils";
import { getDobDate, getDodDate } from "../../common/DisplayDate";
import PhoneSilver from "../Silver/PhoneSilver";

class PersonDetail extends Component {
  componentDidMount() { }

  redirectToSearch = () => {
    if (window.location.href.indexOf("/search/history") === -1) {
      this.props.history.push("/search/history");
    } else {
      window.location.reload();
    }
  };

  redirectToMoreDetails = () => {
    if (
      window.location.href.indexOf("/search/history") === -1 &&
      localStorage.moreDetailsHistoryReportId
    ) {
      // this.props.history.push("/search/history");
      // } else if (localStorage.moreDetailsHistoryReportId) {
      localStorage.historyReportId = localStorage.moreDetailsHistoryReportId;
      localStorage.historyCriteria = localStorage.moreDetailsHistoryCriteria;
      localStorage.xmlId = localStorage.moreDetailsXmlId;
      // window.location.reload();
      this.props.history.push("/search/history");
    }
  };

  render() {
    const results = [];
    const names = [];
    const { isSilverReport } = this.props;
    const hasUniqueId = _.get(
      this.props.reportData,
      "personReport.person[0].uniqueId[0]"
    ) !== undefined;
    let personResult;
    if (
      this.props.reportData !== undefined &&
      this.props.reportData !== null &&
      this.props.reportData !== ""
    ) {
      personResult = isSilverReport
        ? _.get(
          this.props.reportData,
          "personReport.response[0].output[0].extendedReports[0].extendedReport[0]"
        )
        : _.get(this.props.reportData, "personReport.person[0]");
      let name = `${_.get(
        personResult,
        "names[0].name[0].firstName[0]._",
        ""
      )} ${_.get(
        personResult,
        "names[0].name[0].middleInitial[0]._",
        ""
      )} ${_.get(personResult, "names[0].name[0].lastName[0]._", "")}`;
      let nameNodes = _.get(personResult, "names[0].name");
      if (nameNodes !== undefined && nameNodes.length > 1) {
        nameNodes = _.orderBy(nameNodes, (e) => e.$.internalNameID, ["asc"]);
      }
      _.forEach(nameNodes, (nameNode) => {
        const middleName = isSilverReport
          ? getNodeValue(nameNode, "middleName") || ""
          : getNodeValue(nameNode, "middleInitial") || "";
        if (
          this.props.additionalData &&
          this.props.additionalData.internalNameID
        ) {
          if (
            nameNode.$.internalNameID ===
            this.props.additionalData.internalNameID ||
            nameNode.$.internalNameID === "1"
          ) {
            name = `${getNodeValue(
              nameNode,
              "firstName"
            )} ${middleName} ${getNodeValue(nameNode, "lastName")}`;
          }
        }
        names.push(
          `${getNodeValue(nameNode, "firstName")} ${middleName} ${getNodeValue(
            nameNode,
            "lastName"
          )}`
        );
      });

      const personData = PersonMetaData(personResult, this.props.userAccount);
      results.push(
        <Table.Row
          key={`Person_Name_Row report-name-header`}
          className={"report-name-header"}
        >
          <Table.Cell className="icon-align-middle text-center" colSpan={3}>
            {name}
          </Table.Cell>
        </Table.Row>
      );
      const deceased = _.get(
        personResult,
        "SSNInfos[0].SSNInfo[0].SSNDeceased[0]._",
        ""
      ) === "Yes" || _.get(
        personResult,
        "DODs[0].deceasedRecord[0].DOD[0]"
      ) !== undefined;
      if (this.props.userAccount.btType !== "4") {
        results.push(
          <Table.Row
            key={`Person_Name_Sens`}
            className={"report-section-header"}
          >
            <Table.Cell className="icon-align-middle text-center" colSpan={3}>
              Sensitive Information
              {deceased ? (
                <span> Deceased</span>
              ) : null}
            </Table.Cell>
          </Table.Row>
        );
        if (isSilverReport) {
          const ssnRec = _.get(personResult, "SSNs[0].SSNRecord[0]");
          const age = _.get(personResult, "DOBs[0].DOB[0].age[0]._", "");
          let dod;
          if (deceased) {
            dod = getDodDate(_.get(personResult, "DODs[0].deceasedRecord[0].DOD[0]"), this.props);
          }
          results.push(
            <Table.Row key={`Person_Name_Ssn`}>
              {ssnRec && (
                <Table.Cell className={"border-right"}>
                  <span className="text-bold"> SSN: </span>
                  {getSsn(_.get(ssnRec, "SSN[0]._"), this.props)}
                </Table.Cell>
              )}
              {ssnRec && (
                <Table.Cell className={"border-right"}>
                  <span className="text-bold"> ISSUED: </span>
                  {_.get(ssnRec, "years[0]._", "")}
                  <span> in </span>
                  {_.get(ssnRec, "state[0]._", "")}
                </Table.Cell>
              )}
              <Table.Cell colSpan="3">
                <span className="text-bold">DOB: </span>
                {getDobDate(_.get(personResult, "DOBs[0].DOB[0]"), this.props)}
                {!dod || dod === "N/A" &&
                  age !== "" ? (<span>
                    <span className="text-bold padding-left-10"> AGE:  </span>{age}
                  </span>
                ) : null}
                {dod && dod !== "N/A" && (
                  <span>
                    <span className="text-bold padding-left-10">DOD: </span> {dod}
                    <span className="text-bold padding-left-10">Age at Death: </span> {_.get(
                      personResult,
                      "DODs[0].deceasedRecord[0].ageAtDeath[0]._", ""
                    )}
                  </span>
                )}
              </Table.Cell>
            </Table.Row>
          );
        } else {
          if (!hasUniqueId) {
            const ssnRec = _.get(personResult, "SSNRecords[0].SSNRecord[0]");
            personData.ssnYear = _.get(ssnRec, "years[0]._", "");
            personData.ssnLocation = _.get(ssnRec, "state[0]._", "");
            personData.dob = getDobDate(
              _.get(personResult, "DOBs[0].DOB[0]"), this.props
            );
            personData.dod = getDodDate(
              _.get(personResult, "DODs[0].deceasedRecord[0].DOD[0]"), this.props
            );
            personData.age = _.get(
              personResult,
              "DOBs[0].DOB[0].age[0]._",
              ""
            );
          }
          results.push(
            <Table.Row key={`Person_Name_Ssn`}>
              <Table.Cell className={"border-right"}>
                <span className="text-bold"> SSN: </span>
                {getSsn(personData.ssnTiered, this.props)}
              </Table.Cell>
              <Table.Cell className={"border-right"}>
                <span className="text-bold"> ISSUED: </span>
                {personData.ssnYear}
                <span> in </span>
                {personData.ssnLocation}
              </Table.Cell>
              <Table.Cell>
                <span className="text-bold"> DOB: </span>
                {personData.dob}
                {personData.dod !== "" && personData.dod !== "N/A" ? (
                  <span className="text-bold"> DOD: {personData.dod}</span>
                ) : (
                  <span className="text-bold"> AGE: {personData.age}</span>
                )}
              </Table.Cell>
            </Table.Row>
          );
          results.push(<SSNRiskReport key={`SSN_Risk_Info`} {...this.props} />);
        }
      }
    }
    const phones = _.get(personResult, "phones[0]");
    return (
      <div>
        <Table stackable key={"Person_Header_Name"}>
          <Table.Body>
            <Table.Row>
              <Table.Cell>
                <div className={`no-print`}>
                  {/* {window.location.href.indexOf("/search/history") === -1 &&
                    localStorage.moreDetailsHistoryReportId &&
                    localStorage.historyReportId !== "" &&
                    localStorage.xmlId !== "" && (
                      <Button
                        className="margin-left-10"
                        onClick={this.redirectToMoreDetails}
                      >
                        Back
                      </Button>
                    )}
                  {window.location.href.indexOf("/search/history") === -1 &&
                    localStorage.historyReportId !== "" &&
                    localStorage.xmlId !== "" && (
                      <Button
                        className="margin-left-10"
                        onClick={this.redirectToSearch}
                      >
                        Results
                      </Button>
                    )} */}
                  <Button
                    className={"margin-left-10"}
                    onClick={() => this.props.printContent("report", `Report`)}
                  >
                    Print
                  </Button>
                </div>
              </Table.Cell>
              <Table.Cell />
              <Table.Cell width={6} textAlign={`right`}>
                <div className={`no-print`}>
                  <CaseComponent
                    {...this.props}
                    actId={_.get(
                      this.props.reportData,
                      "personReport.log[0].actID[0]"
                    )}
                    compType={"result"}
                  />
                </div>
              </Table.Cell>
            </Table.Row>
            {results}
          </Table.Body>
        </Table>
        {names.length > 0 ? (
          <Table stackable key={"Person_Possible_Aliasses"}>
            <Table.Body>
              <Table.Row className="report-section-header">
                <Table.Cell className={"text-center"}>
                  Possible Aliases
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>{_.join(names, ", ")}</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        ) : null}

        <Table
          className={"table-no-border-and-padding"}
          stackable
          key={"Person_Row_Phone_Counties"}
        >
          <Table.Body>
            {phones !== undefined ? (
              <Table.Row>
                <Table.Cell width={9} style={{ padding: "0 !important", margin: "0" }}>
                  <PhoneSilver
                    {...this.props}
                    node={phones}
                  />
                </Table.Cell>
                <Table.Cell width={7}>
                  <Counties {...this.props} node={personResult} />
                </Table.Cell>
              </Table.Row>
            ) : (
              <Table.Row>
                <Table.Cell width={9}>
                  <Phone {...this.props} node={personResult} displayCarrier />
                </Table.Cell>
                <Table.Cell width={7}>
                  <Counties {...this.props} node={personResult} />
                </Table.Cell>
              </Table.Row>
            )}
          </Table.Body>
        </Table>
      </div>
    );
  }
}

export default PersonDetail;



// WEBPACK FOOTER //
// ./src/components/reports/Platinum/PersonDetail.js